import LowHierarchySelection from '../../../../dataViews/NextTree/plugins/LowHierarchySelection';
export default {
    makeTreePlugin: canSelectNode => new LowHierarchySelection({ nodeIsSelectable: canSelectNode }),
};
